<template>
<nav id="user-nav">
  <ul class="nav nav-pills">
    <li>
      <router-link :to="{
        name: 'users'
      }">
        Users
      </router-link>
    </li>
    <li>
      <router-link :to="{
        name: 'create_user'
      }">
        New User
      </router-link>
    </li>
    <li v-if="userId && this.$root.isAdmin">
      <router-link :to="{
        name: 'edit_user',
        params: { userId: userId }
        }"
      >
        Edit User
      </router-link>
    </li>
    <li v-if="userId && this.$root.isAdmin">
      <router-link :to="{
        name: 'edit_user_details',
        params: { userId: userId }
        }"
      >
        Edit User Profile
      </router-link>
    </li>
    <li v-if="this.$root.isAdmin">
      <router-link :to="{
        name: 'debug_auth',
        params: { userId: userId }
        }"
      >
        Debug User Auth
      </router-link>
    </li>
  </ul>
</nav>
</template>

<script>
export default {
  props: ['userId']
}
</script>

<style scoped>
main nav {
  margin-bottom: 1em;
}

.nav {
  border-top: 0
}
</style>



// WEBPACK FOOTER //
// src/components/UserNav.vue